import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        if (typeof window !== "undefined") {
            return localStorage.getItem("sukhakarta_lang") || "mr";
        }
        return "mr";
    });

    useEffect(() => {
        if (typeof window !== "undefined") {
            localStorage.setItem("sukhakarta_lang", lang);
            document.documentElement.setAttribute("lang", lang === "mr" ? "mr" : "en");
        }
    }, [lang]);

    const toggle = () => setLang((l) => (l === "mr" ? "en" : "mr"));

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggle }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
};

// Convenience helper: pick translated string from {en, mr} object or pass raw string
export const useT = () => {
    const { lang } = useLang();
    return (entry) => {
        if (entry == null) return "";
        if (typeof entry === "string") return entry;
        return entry[lang] ?? entry.en ?? "";
    };
};
